import { render, staticRenderFns } from "./contact-form.vue?vue&type=template&id=0748317d"
import script from "./contact-form.vue?vue&type=script&lang=js"
export * from "./contact-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/whitewe_jisheng-mes-ui_CPvN/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0748317d')) {
      api.createRecord('0748317d', component.options)
    } else {
      api.reload('0748317d', component.options)
    }
    module.hot.accept("./contact-form.vue?vue&type=template&id=0748317d", function () {
      api.rerender('0748317d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/home-page/contact-form.vue"
export default component.exports